var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('va-location-field',{attrs:{"points":_vm.points,"zoom":11,"multiple":"","height":"500px"}}),_c('base-material-card',{attrs:{"icon":_vm.resource.icon,"title":_vm.title}},[_c('va-list',{attrs:{"filters":_vm.filters,"include":[
        'pump_type',
        'irrigation_water_source_entity',
        'watercourse',
      ]},on:{"update:listState":_vm.onListStateUpdate}},[_c('va-data-table',{attrs:{"fields":_vm.fields,"disable-clone":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }